<template>

    <form class="mt-2" id="form-modal">
        <!--  -->
         <div class="col-md-12 px-0" v-if="action == 'add_organization_for_support_ticket'">
            <div class="form-group" >
              <h5 class="mt-0 mb-2 text-dark" style="color:#48a6a6 !important">{{formData.ticket_title}}</h5>

              <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Organization<span style="color: red">*</span>:</label>
                    <multiselect :options="organizations" :allow-empty="true" :searchable="true" :multiple="false"
                        :selectedLabel="null" :deselectLabel="null"  :selectLabel="null" @input="orgusers()" v-model="organizations_selected" label="name" track-by="id"></multiselect>
                </div>
                 <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Organization User</label>
                    <multiselect :options="orgUsers" :allow-empty="true" :searchable="true" :multiple="false"
                        :selectedLabel="null" :deselectLabel="null"  :selectLabel="null"  label="user_name" track-by="id" v-model="org_user" :loading="loading">
                    </multiselect>
                </div>

                    <div class="text-right mt-4">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                        <button :style= "[mini_loading ? { 'pointer-events' : 'none' } : { 'pointer-events' : 'auto' }]" type="button" class="btn btn-default ml-1" @click="saveOrgUsers">
                            <font-awesome-icon v-if="mini_loading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
                            {{"Update"}}
                        </button>
                    </div>
            </div>
		 </div>


    <div class="col-md-12 px-0" v-else-if="action == 'add_qa'">
        <div class="form-group" v-if="[userRoles.qa, userRoles.adh].includes(role)" >
        <h5 class="mt-0 mb-2 text-dark" style="color:#48a6a6 !important">{{formData.task.title}} </h5>
                <div v-for="(issue, index) in parsedTaskIssues" :key="index" class="d-flex align-items-center mb-2">
                    <input
                    :id="'task-title-' + index"
                    type="text"
                    v-model="issue.task_issue"
                    class="form-control mr-2"
                    placeholder="Issue"
                    />
                    <select v-model="issue.status" class="form-control mr-2" style="max-width: 140px;">
                      <option v-for="opt in issueStatusOptions" :key="opt.value" :value="opt.value">{{ opt.name }}</option>
                    </select>

                    <button
                    type="button"
                    class="btn add-more-cross-btn shadow-none"
                    @click="removeIssue(index)"
                    :style="{ opacity: index === 0 ? '50%' : '100%' }"
                    :disabled="parsedTaskIssues.length === 0"
                    >
                    <i  class="fas fa-trash"></i>
                    </button>

                </div>
                <button type="button" @click="addIssue" class="btn add-more-btn shadow-none"> <span class="me-2 ">+ </span> Add More</button>

             <div class="text-right mt-4">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    Close
                </button>
                <button :style= "[mini_loading ? { 'pointer-events' : 'none' } : { 'pointer-events' : 'auto' }]" type="button" class="btn btn-default ml-1" @click="saveIssue">
                    <font-awesome-icon v-if="mini_loading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
                    {{"Update"}}
                </button>
			 </div>
		   </div>
		 </div>

        <div class="col-md-12 px-0" v-else-if="action == 'developer_report'">
            <div class="form-group">
                <div v-for="(report, index) in reports" :key="index" class="d-flex align-items-center mb-2">
                    <input
                    :id="'task-title-' + index"
                    type="text"
                    v-model="report.title"
                    class="form-control mr-2"
                    placeholder="Task Title"
                    />
                    <input
                    :id="'task-hours-' + index"
                    type="number"
                    v-model="report.hours"
                    @blur="validateHours(report)"
                    class="form-control mr-2"
                    placeholder="Hours"
                    style="width: 100px;"
                    />
                    <button
                    type="button"
                    class="btn add-more-cross-btn shadow-none"
                    @click="removeReport(index)"
                    :style="{ opacity: index === 0 ? '50%' : '100%' }"
                    :disabled="reports.length === 1"
                    >
                    <i  class="fas fa-trash"></i>
                    </button>
                </div>
                <button type="button" @click="addReport" class="btn add-more-btn shadow-none"> <span class="me-2 ">+ </span> Add More</button>
            </div>

            <div class="form-group">
                    <label  style="color: #48a6a6; font-weight: 600; font-size: 14px">Enter date to which you want to add report</label>
                    <input class="form-control" @input="changeDate()" :min="task.min_date" type="date" placeholder="Due Date" v-model="rpt_date" :max="maxDate">
                </div>
                <div class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Description<span style="color: red">*</span>:</label>
                    <div class="text_editor">
                        <tiny-mce-editor :vModelName.sync="dev_description"></tiny-mce-editor><br />
                    </div>
                </div>
                <div class="text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    Close
                </button>
                <button :style= "[mini_loading ? { 'pointer-events' : 'none' } : { 'pointer-events' : 'auto' }]" type="button" class="btn btn-default ml-1" @click="save">
                    <font-awesome-icon v-if="mini_loading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
                    {{"Update"}}
                </button>
            </div>
        </div>

        <!--  -->
        <div class="col-md-12 px-0" v-else-if="action == 'onholdtask'">
                <div class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Reason<span style="color: red">*</span>:</label>
                    <div class="text_editor">
                        <tiny-mce-editor :vModelName.sync="onholddescription"></tiny-mce-editor><br />
                    </div>
                </div>
                <div class="text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    Close
                </button>
                <button :style= "[mini_loading ? { 'pointer-events' : 'none' } : { 'pointer-events' : 'auto' }]" type="button" class="btn btn-default ml-1" @click="saveOnHoldReason">
                    <font-awesome-icon v-if="mini_loading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
                    {{"Save"}}
                </button>
            </div>
        </div>
        <div class="col-md-12 px-0"  v-else>
            <div v-if="action != 'extend_due_date'">
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Title<span style="color: red">*</span>:</label>
                    <input type="text" v-model="task.title" class="form-control" placeholder="Title" />

                </div>
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Description<span style="color: red">*</span>:</label>
                    <div class="text_editor">
                        <tiny-mce-editor :vModelName.sync="task.description"></tiny-mce-editor><br />
                    </div>
                </div>
                <div v-if="action != 'add_task_from_Support_ticket' && (action == 'create' ||  action == 'assign_to') && role != 10 && ![userRoles.development_lead].includes(role)" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Due Date</label>
                    <input type="datetime-local" v-model="task.due_date" class="form-control" placeholder="Due Date" />
                </div>
                <!-- Required only for csm -->
               <!-- Show input with required indication for action 'add_task_from_Support_ticket' -->
                    <div v-if="action === 'add_task_from_Support_ticket'" class="form-group">
                        <label style="color: #48a6a6; font-weight: 600; font-size: 14px">
                            Required Due Date
                            <span v-if="[userRoles.admin, userRoles.csm, userRoles.super_admin].includes(role)" style="color: red">*</span>:
                        </label>
                        <input type="datetime-local" v-model="task.req_due_date" class="form-control" placeholder="Due Date" />
                    </div>

                    <!-- Show input without required indication for actions 'create' or 'edit' -->
                    <div v-else-if="action == 'create' || action !== 'edit'" class="form-group">
                        <label style="color: #48a6a6; font-weight: 600; font-size: 14px">
                            Required Due Date
                            <span v-if="[userRoles.admin, userRoles.csm, userRoles.super_admin].includes(role)" style="color: red"></span>:
                        </label>
                        <input type="datetime-local" v-model="task.req_due_date" class="form-control" placeholder="Due Date" />
                    </div>

                <div v-if="action != 'add_task_from_Support_ticket' && (action == 'create' ||  action == 'assign_to') && ($can('add_task_dev_due_date') || $can('view_task_assign_to_dev_date'))" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Developer Due Date</label>
                    <input type="date" v-model="task.dev_due_date" class="form-control" placeholder="Due Date" />
                </div>
                <div v-if="action != 'add_task_from_Support_ticket' && (action == 'create' ||  action == 'assign_to')  && ($can('add_task_adh_due_date') || $can('view_task_assign_to_adh_date'))"  class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">ADH Due Date</label>
                    <input type="date" v-model="task.adh_due_date" class="form-control" placeholder="Due Date" />
                </div>

                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Task Type<span style="color: red">*</span>:</label>
                    <!-- <input type="text" class="form-control"  placeholder="Priority" /> -->
                     <multiselect v-model="task_type" :options="taskTypesList" :multiple="false" :selectedLabel="null" :deselectLabel="null" :allow-empty="false"
                     :selectLabel="null" :internal-search="true" label="name" track-by="value" placeholder="Task Type">
                    </multiselect>
                </div>
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Priority<span style="color: red">*</span>:</label>
                    <!-- <input type="text" class="form-control"  placeholder="Priority" /> -->
                     <multiselect v-model="priority" :options="prioritiesList" :multiple="false" :selectedLabel="null" :deselectLabel="null" :allow-empty="false"
                     :selectLabel="null" :internal-search="true" label="name" track-by="value" placeholder="Priority">
                    </multiselect>
                </div>
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Customer<span style="color: red">*</span>:</label>
                    <multiselect :options="organizations" :allow-empty="true" :searchable="true" :multiple="true"
                        :selectedLabel="null" :deselectLabel="null"  :selectLabel="null" v-model="organizations_selected" label="name" track-by="id"></multiselect>
                </div>
                  <div v-if="action != 'assign_to'" class="form-group">
                    <label class="label-form" style="color: #48a6a6; font-weight: 600; font-size: 14px">Software<span style="color: red">*</span>:</label>
                    <multiselect   :options="softwareOptions"   :selectedLabel="null" :deselectLabel="null" :allow-empty="true"
                        v-model="software" :selectLabel="null" :internal-search="true" label="name" track-by="id" placeholder="Software">
                    </multiselect>
                </div>
                <div v-if="action != 'assign_to'" class="form-group">
                    <label class="label-form" style="color: #48a6a6; font-weight: 600; font-size: 14px">Attach Document:</label>
                    <input type="file" ref="document" class="form-control"
                      @change="handleTaskDocumentUpload"
                      accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" />
                    <small v-if="action === 'edit' && getExistingDocumentUrl()" class="form-text text-muted">
                      Current document:
                      <a :href="getExistingDocumentUrl()" target="_blank" rel="noopener noreferrer">
                        {{ getDocumentName(getExistingDocumentUrl()) }}
                      </a>
                    </small>
                </div>

                <div v-if="action != 'assign_to'" class="form-group">
                    <label class="label-form" style="color: #48a6a6; font-weight: 600; font-size: 14px">PR Link:</label>
                    <input type="text" v-model="task.pr_link" class="form-control" placeholder="PR Link" />
                </div>
                <div  class="form-group">
                    <label class="label-form" style="color: #48a6a6; font-weight: 600; font-size: 14px">Team</label>
                    <multiselect v-if="role == 7"  :options="adhteams"   :selectedLabel="null" :deselectLabel="null" :allow-empty="true"
                        v-model="user.team" :selectLabel="null" :internal-search="true" label="name" track-by="id" placeholder="Team">
                    </multiselect>
                    <multiselect v-else  @input="Changeteam" :options="teams"   :selectedLabel="null" :deselectLabel="null" :allow-empty="true"
                        v-model="user.team" :selectLabel="null" :internal-search="true" label="name" track-by="id" placeholder="Team">
                    </multiselect>
                </div>
                <div v-if="[userRoles.development_lead,userRoles.admin,userRoles.super_admin,userRoles.adh].includes(role)"  class="form-group">
                <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Developer:</label>
                    <multiselect v-model="assigned_to" :options="allDevelopers" :selectedLabel="null" :deselectLabel="null" :allow-empty="false"
                        :selectLabel="null" :searchable="true" label="full_name" track-by="id" style="font-size:12px !important" >
                    </multiselect>
                </div>
                 <div v-if="action === 'edit' || $can('add_task_team') && action != 'assign_to' "  class="form-group">
                <label style="color: #48a6a6; font-weight: 600; font-size: 14px">QA:</label>
                    <multiselect v-model="selectedQa" :options="qaOptionsWithFullName" :selectedLabel="null" :deselectLabel="null" :allow-empty="false"
                        :selectLabel="null" :searchable="true" label="full_name" track-by="id" style="font-size:12px !important" placeholder="Select Qa">
                    </multiselect>
                </div>
            </div>
            <div v-if="action == 'extend_due_date'">
                <div v-show="task.prev_due_date" class="form-group">
                    <p>Due-Date is {{task.task_due_date_time }}</p>
                </div>
                <!-- <div class="form-group">
                    <label class="label-form"  style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px">Due-Date<span style="color: red">*</span>:</label>
                    <multiselect  :options="due_date_types"  placeholder='Select Due-Date Type' @input="updateStatus" :multiple="false"
                        :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true"
                        v-model="due_date_type" label="type" track-by="value" style="font-size:12px !important">
                    </multiselect>
                </div> -->
                <div class="form-group">
                    <label  style="color: #48a6a6; font-weight: 600; font-size: 14px">Enter date & time to which you want to {{ extendText(task,'due_date') }} due-date<span style="color: red">*</span>:</label>
                    <input class="form-control" :min="task.min_date" type="datetime-local" placeholder="Due Date" v-model="task.extend_due_date">
                </div>
                <div class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Reason<span style="color: red">*</span>:</label>
                    <textarea type="text"  v-model="task.extend_due_date_comment" class="form-control" placeholder="Reason" />
                </div>
            </div>
            <!-- <div v-if="action != 'moveToDevelopment' && action != 'extend_due_date'">
                <div v-if="action != 'moveToDevelopment' && action != 'extend_due_date'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Due Date<span style="color: red">*</span>:</label>
                    <input type="date" v-model="due_date" class="form-control" placeholder="Due Date" />
                </div>
                <div class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Developer<span style="color: red">*</span>:</label>
                    <multiselect v-model="developer" :options="formData.developers" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true"
                    label="full_name" track-by="id" style="font-size:12px !important">
                  </multiselect>
                </div>
            </div> --> <!-- <div class="text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    Close
                </button>
                <button :style= "[mini_loading ? { 'pointer-events' : 'none' } : { 'pointer-events' : 'auto' }]" type="button" class="btn btn-default ml-1" @click="save">
                    <font-awesome-icon v-if="mini_loading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
                    {{action != 'edit' ? "Save" : "Update"}} 
                </button>
            </div>
             buttons -->
            <div class="text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    Close
                </button>
                <button :style= "[mini_loading ? { 'pointer-events' : 'none' } : { 'pointer-events' : 'auto' }]" type="button" class="btn btn-default ml-1" @click="save">
                    <font-awesome-icon v-if="mini_loading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
                    {{action != 'edit' ? "Save" : "Update"}}
                </button>
            </div>
            <table v-if="[userRoles.admin,userRoles.super_admin,userRoles.adh].includes(role) && action == 'extend_due_date'" class="table table-bordered table-hover  mt-5 text-center">
                <th style="color:#48a6a6;" colspan="3"><b>Due Date History</b></th>
                <tbody>
                    <tr>
                    <th style="width: 35%;">Due Date</th>
                    <th style="width: 30%;">At</th>
                    <th style="width: 35%;">Updated By</th>
                    </tr>
                    <tr  v-if="loader" id="table_row" >
                        <td colspan="16">
                        <b-skeleton-wrapper >
                            <b-skeleton height="40px" ></b-skeleton>
                            <b-skeleton height="40px"></b-skeleton>
                            <b-skeleton height="40px"></b-skeleton>
                        </b-skeleton-wrapper>
                        </td>
                    </tr>
                    <tr v-else class="mt-2" v-for="dueDateRow in due_date_history" :key="dueDateRow.id">
                        <td  style="width: 35%;"> <p style="white-space: break-spaces">{{ dueDateRow.due_date |formatDate }}</p> </td>
                        <td  style="width: 30%;"> <p style="white-space: break-spaces">{{ dueDateRow.created_at |formatCreatedAtDate}}</p> </td>
                        <td style="width: 35%;"> <p style="white-space: break-spaces">{{ dueDateRow.created_by.first_name }} {{ dueDateRow.created_by.last_name }}</p> </td>
                    </tr>
                    <tr v-if="!loader && due_date_history.length < 1">
                        <td  colspan="3">
                            No Due-Date History Found.
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </form>

</template>

<script>
    import Multiselect from "vue-multiselect";
    import axios from 'axios';
    import moment from "moment";
    import TinymceEditor from "../../../../views/partials/tiny_mce_editor";
  import { mapGetters,  mapActions } from 'vuex';
    Vue.filter("formatDate", function (value) {
        if (value != "0000-00-00" && value != null) {
            return moment(String(value)).format("MMM DD, Y");
        }
    });
    Vue.filter("formatCreatedAtDate", function (value) {
        if (value != "0000-00-00" && value != null) {
            return moment(String(value)).format("MMM DD, Y h:mm a");
        }
    });
    export default {
        components: {
            Multiselect,
            "tiny-mce-editor": TinymceEditor,
        },
        props:  ['formData','action', 'testData'],
        data: function(){
            return{
                parsedTaskIssues: [{ task_issue: '', status: 0 }],
                issueStatusNames: {
                  0: 'Open',
                  1: 'In Progress',
                  2: 'Fixed',
                  3: 'Verified',
                  4: 'Re-Open',
                  5: 'Again Fixed',
                  6: 'Re-Verified',
                  7: 'Deferred',
                },
                issueStatusOptions: [
                  { name: 'Open', value: 0 },
                  { name: 'In Progress', value: 1 },
                  { name: 'Fixed', value: 2 },
                  { name: 'Verified', value: 3 },
                  { name: 'Re-Open', value: 4 },
                  { name: 'Again Fixed', value: 5 },
                  { name: 'Re-Verified', value: 6 },
                  { name: 'Deferred', value: 7 },
                ],
                reports: [{ title: '', hours: '' }],
                task: {
                    id: null,
                    title: '',
                    description: '',
                    due_date: '',
                    req_due_date:'',
                    dev_due_date:'',
                    adh_due_date:'',
                    document: null,
                    pr_link: '',
                    status: 1,
                    assigned_to_selected: {},
                    task_type_selected: {},
                    priority_selected: {},
                    organizations_selected: [],
                    support_ticket_id: '',
                    prev_due_date:'',
                    extend_due_date: '',
                    extend_due_date_comment: '',
                    activity_type: '',
                    min_date: '',
                    prms:'',
                    user_team: [],
                    organizations_obj: [],
                    product:'',
                    qa_to:'',
                },
                user_id:localStorage.getItem('admin_id'),
                loader:true,
                assigned_to:{},
                task_type:{},
                priority:{},
                organizations_selected:{},
                due_date_history: [],
                taskForm:{},
                organizations: [],
                org: '',
                org_search_value: "all",
                developers:[],
                mini_loading:false,
                role: JSON.parse(localStorage.getItem("role")),
                user: this.get_empty_user_obj(),
                team_developers :[],
                allDevelopers : [],
                adhteams:{},
                dev_description: '',
                rpt_date: '',
                onholddescription: '',
                softwareOptions: {},
                software:{},
                selectedQa: {},
                userAssignedProduct :localStorage.getItem("user_product"),
                orgUsers:[],
                org_user:'',
                loading: false




                // due_date_types:[
                //     {"value":0,"type":"Due Date"},
                //     {"value":1,"type":"Developer Due Date"},
                //     {"value":2,"type":"ADH Due Date"}
                // ],


            };
        },
        computed: {
            prioritiesList: function () {
                return this.$store.getters['tasks/prioritiesList'];
            },
            activityTypes: function () {
                return this.$store.getters['tasks/activityTypes'];
            },
            // taskTypesList: function () {
            //     return this.$store.getters['tasks/taskTypesList'];
            // },
            userRoles: function () {
				return this.$store.getters['persist/userRoles'];
			},
            msaterUsers: function () {
				return this.$store.getters['persist/orgUsers'];
			},
            taskDetails: function () {
                return this.$store.getters['tasks/task'];
            },

            filteredAdminUsers:function(){

                return this.$store.getters['persist/getQa'];
            },
            qaOptionsWithFullName() {
                const list = this.filteredAdminUsers || [];
                return list.map(u => ({
                    ...u,
                    full_name: (u.first_name && u.last_name)
                        ? (u.first_name + ' ' + u.last_name)
                        : (u.full_name || u.first_name || u.last_name || u.name || '')
                }));
            },
            ...mapGetters('persist', ['teams']),
            filteredTeams() {
                return this.teams.filter(team =>
                    team.team_developer.some(developer => developer.user_id == this.user_id)
             );

            },
            maxDate: function(){
            return new Date().toISOString().split('T')[0];
            },
             ...mapGetters('persist', ['taskTypesList']),

        },
        mounted: function(){
            this.on_load_component();
        },
        created: function () {
            this.getOrganizations();
            let users = this.$store.getters['persist/orgUsers'];
            this.orgUsers = users.filter(user => user.organization_id == this.organizations_selected.id);

            if(this.formData.user_id != null)
            {
                this.org_user = users.filter(user => user.id == this.formData.user_id);
            }
            this.softwareOptions =  this.$store.getters['persist/availableProducts'];

            this.softwareOptions = this.softwareOptions.filter(product =>
                this.userAssignedProduct.includes(product.id)
                );
             this.getAllType();
            if(this.action == 'add_qa')
            {
                this.parsedTaskIssues = this.normalizeIssues(this.formData.task.qa_issue);
				if(this.parsedTaskIssues.length<1)
				{
					this.parsedTaskIssues=[{ task_issue: '', status: 0 }];
				}
            }

        },
        watch:{
            'formData.task.qa_issue': {
					handler(newVal, oldVal) {
					this.parsedTaskIssues = (this.parsedTaskIssues.length === 0 || !newVal) ? [{ task_issue: '', status: 0 }] : this.normalizeIssues(newVal)
					},
					deep: true
				},
            filteredTeams: {
                handler(newFilteredTeams) {
                     this.adhteams = newFilteredTeams;
                },
                immediate: true
            },
            formData: {
                handler: 'on_load_component', // Replace 'onFormDataChange' with the actual method name
                deep: true, // Optional, if you need to deep watch for changes
            },
             selectedQa(newValue) {
                if (newValue) {
                    this.task.qa_to = newValue.id;
                } else {
                    this.task.qa_to = null;
                }
             },
        formData: {
                handler: 'on_load_component', // Replace 'onFormDataChange' with the actual method name
                deep: true, // Optional, if you need to deep watch for changes
            },

            'formData.prevReports': {
                        handler(newVal) {
                                if (newVal) {
                                let val  = JSON.parse(newVal.task_details);
                                this.reports = val.map(report => ({ title: report.title, hours: report.hours }));
                                this.dev_description = newVal.task_description;
                                this.rpt_date = newVal.report_date;
                                }else{
                                    this.reports = [{ title: '', hours: '' }];
                                    this.dev_description = '';
                                    this.rpt_date = new Date().toISOString().slice(0, 10);

                                }
                        },
                    immediate: true, // This ensures the handler runs immediately after component initialization
                    deep: true // Watches for nested changes in objects/arrays
             },

            'user.team': function(newTeam, oldTeam) {

                    if (newTeam !== oldTeam && newTeam) {
                    this.team_developers = newTeam.team_developer
                    .filter(developer =>
                        this.formData.developers.some(alldev =>
                        alldev.id === developer.user_id
                        )
                    )
                    .map(developer => developer.user_id);

                    this.allDevelopers = this.formData.developers.filter(developer =>
                    this.team_developers.includes(developer.id)
                    );

                }
            },

          organizations_selected(newVal) {
            this.orgusers(newVal.id);
          }

        },
        methods: {
          getExistingDocumentUrl() {
            // Back-end already provides full S3 link
            return (this.task && this.task.s3_document) || "";
          },
          getDocumentName(url) {
            if (!url || typeof url !== "string") return "--";
            const cleaned = url.replace(/\\\//g, "/");
            const withoutQuery = cleaned.split("?")[0].split("#")[0];
            const parts = withoutQuery.split("/");
            const last = parts[parts.length - 1] || "";
            return last || "--";
          },
          handleTaskDocumentUpload(event) {
            const file = this.$refs.document && this.$refs.document.files ? this.$refs.document.files[0] : null;
            this.task.document = file;
            
            if (!file) {
              this.task.document = null;
              return;
            }

            // Block images (png/jpg/jpeg and any image/*)
            const name = (file.name || '').toLowerCase();
            const ext = name.includes('.') ? name.slice(name.lastIndexOf('.') + 1) : '';
            const mime = file.type || '';
            const isImage = mime.startsWith('image/') || ['png', 'jpg', 'jpeg'].includes(ext);
            const isAllowedDoc =
              mime === 'application/pdf' ||
              mime === 'application/msword' ||
              mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
              ['pdf', 'doc', 'docx'].includes(ext);

            if (isImage || !isAllowedDoc) {
              this.$toast.error('Only PDF or Word documents (DOC/DOCX) are allowed.');
              this.task.document = null;
              if (this.$refs.document) this.$refs.document.value = '';
              return;
            }

            this.task.document = file;
          },

          async orgusers(selectedOrg) {
            this.loading = true;
            if (selectedOrg) {
              this.orgUsers = await this.$store.dispatch('users/orgMasterUsers', selectedOrg);
              if (this.orgUsers)
                this.loading = false;
            } else {
              this.orgUsers = []; // Clear the users list if no organization is selected
            }
          },
			async saveIssue() {
                if (this.validateDeveloperIssueForm()) {
                    this.mini_loading = true;
                    const issues = this.normalizeIssues(this.parsedTaskIssues);
                    let formData = {
                        task_id: this.formData.task_id,
                        issues,
                    };

                    try {
                        let response = await this.$store.dispatch("tasks/taskIssue", {formData});
                        this.mini_loading = false;
                        if (response && response.error) {
                            this.serverValidationErrors(response.error);
                        } else {
                            this.$toast.success(response);

                            let filtersData = [
                                this.$store.getters['tasks/currentPage'],
                                this.$store.getters['tasks/filters'],
                                []
                            ];
                             this.$store.dispatch("tasks/getAll", filtersData);
                            window.$('#modal').modal('hide');
                        }
                    } catch (error) {
                        this.mini_loading = false;
                        // Handle error, if needed
                        console.error(error);
                    }
                } else {
                    this.mini_loading = false;
                }
            },
            async saveOrgUsers(){
                  if(!this.organizations_selected){
                    this.$toast.error('The Organization field is required');
                        return false;
                   }
                this.mini_loading = true;

                let formData = {
                    org_id: this.organizations_selected.id,
                    user_id: this.org_user ? this.org_user.id : null,
                    ticket_id: this.formData.ticket_id
                };
                try {
                    let response = await this.$store.dispatch("users/updateOrgUser", {formData});
                    if (response && response.message) {
                          this.showskLoader = true;
                        await this.$store.dispatch("support/getAllTickets", [this.formData.page, this.formData.ticket_current_status,'',false])
                        .then(()=>{
                            this.showskLoader = false;
                        });
                        this.$toast.success("Record has been updated successfully");
                        this.mini_loading = false;
                        window.$('#modal').modal('hide');
                    } else {
                        this.serverValidationErrors(response.error);
                        this.mini_loading = false;

                    }
                } catch (error) {
                    this.mini_loading = false;
                    console.error(error);
                }
            },
			validateDeveloperIssueForm () {
                let isValid = true;
				this.parsedTaskIssues.forEach(report => {
				if (!report.task_issue || !report.task_issue.trim()) {
					report.isValid = false;
					isValid = false;
                }else{
                    report.isValid = true;
                    if (report.status === null || report.status === undefined || report.status === '') report.status = 0;
					}
                });
                if(!isValid)
                    {
                        this.$toast.error('Issue fields are required');
                    }
                return isValid;
            },
			addIssue() {
            this.parsedTaskIssues.push({ task_issue: '', status: 0 }); // Add a new issue row
            },
            removeIssue(index) {
            if (this.parsedTaskIssues.length >= 1) {
                this.parsedTaskIssues.splice(index, 1); // Remove the task at the specified index
            }
            },
            getIssueStatusName(value) {
              const v = Number(value);
              return this.issueStatusNames.hasOwnProperty(v) ? this.issueStatusNames[v] : 'Open';
            },
            normalizeIssues(list) {
              let safeList = [];
              if (Array.isArray(list)) {
                safeList = list;
              } else if (typeof list === 'string' && list.trim() !== '') {
                // Some endpoints may return `qa_issue` as a JSON string.
                try {
                  const parsed = JSON.parse(list);
                  safeList = Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                  safeList = [];
                }
              }
              return safeList.map((it) => {
                const issue = it && typeof it === 'object' ? { ...it } : { task_issue: '' };
                const s = issue.status;

                // legacy: only boolean true was "fixed" in old 0/1 model; numeric 1 is "In Progress"
                if (s === true) issue.status = 2; // Fixed
                else if (s === false || s === 0 || s === '0' || s === null || s === undefined || s === '') issue.status = 0; // Open
                else if (typeof s === 'number' && this.issueStatusNames.hasOwnProperty(s)) issue.status = s;
                else if (typeof s === 'string') {
                  // string label → numeric value
                  const match = this.issueStatusOptions.find((o) => o.name === s);
                  issue.status = match ? match.value : 0;
                } else {
                  issue.status = 0;
                }

                return issue;
              });
            },
             ...mapActions('teams', ['getAllType']),
            addReport() {
            this.reports.push({ title: '', hours: '' }); // Add a new task with an empty title
            },
            extendText(item,date_type) {
                return item[date_type] ? 'extend' : 'set';
                },
            removeReport(index) {
            if (this.reports.length > 1) {
                this.reports.splice(index, 1); // Remove the task at the specified index
            }
            },
            validateHours(report) {
                if (report.hours < 1) {
                report.hours = 1;
                } else if (report.hours > 8) {
                report.hours = 8;
                }
            },
            get_empty_user_obj() {
                return { user_name: '', password: '', first_name: '', last_name: '', email: '', role_id: '',team:[] ,software:{}, client_id: '', client_secret: '',account_id: '' };
            },
            async changeDate() {

                let prevReportDateWise = await this.$store.dispatch("tasks/prevReportByDate", {
                    task_id: this.formData.task_id,
                    pdate: this.rpt_date,
                    prms: 'task_progress'
                });
            if(prevReportDateWise)
            {
                let value  = JSON.parse(prevReportDateWise.task_details);
                this.reports = value.map(report => ({ title: report.title, hours: report.hours }));
                this.dev_description = prevReportDateWise.task_description;
            }
            else{
                this.reports = [{ title: '', hours: '' }];
                this.dev_description = '';
              }
            },

            on_load_component () {
                if (this.action == 'edit') {
                    this.task = { ...this.formData.task };
                    // this.task.due_date = task.due_date != '' ? moment(new Date(task.due_date).toISOString()).format("Y-MM-DD") : ''
                    this.task.due_date = this.task.due_date ? new Date(this.task.due_date).toISOString().slice(0, 10) : '';
                    this.task.req_due_date = this.task.req_due_date ? new Date(this.task.req_due_date).toISOString().slice(0, 10) : '';
                    this.task.dev_due_date = this.task.dev_due_date ? new Date(this.task.dev_due_date).toISOString().slice(0, 10) : '';
                    this.task.adh_due_date = this.task.adh_due_date ? new Date(this.task.adh_due_date).toISOString().slice(0, 10) : '';
                    this.task.status = this.task.status;
                    this.assigned_to =  {full_name: this.task.assigned_to.name, id: this.task.assigned_to.id};
                    // this.task.assigned_to_selected =  this.assigned_to;
                    this.task_type = this.taskTypesList.find(opt => opt.value == this.task.task_type);
                    const qaList = this.qaOptionsWithFullName;
                    const qaId = this.task.qa_to && (typeof this.task.qa_to === 'object' ? this.task.qa_to.id : this.task.qa_to);
                    const qaName = this.task.qa_to && typeof this.task.qa_to === 'object' ? this.task.qa_to.name : null;
                    this.selectedQa = qaList.length && (qaId || qaName)
                        ? (qaList.find(opt => opt.id == qaId)
                            || (qaName && qaList.find(opt => (opt.first_name + ' ' + opt.last_name) === qaName))
                            || (qaName && qaList.find(opt => opt.first_name == qaName)))
                        : null;
                    this.priority= this.prioritiesList.find(opt => opt.value == this.task.priority);
                    this.user.team= this.teams.find(opt => opt.id === this.task.team_id);
                    this.software= this.softwareOptions.find(opt => opt.id === this.task.product);
                    this.updateOrganizations();
                } else if (this.action == 'add_task_from_Support_ticket') {
                    this.task.support_ticket_id = this.formData.ticket_id;
                    this.task.req_due_date = moment(`${this.formData.ticket_date} ${this.formData.ticket_time}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DDTHH:mm");
                    this.task.status = 0;
                    this.task.title = this.formData.ticket_title;
                    this.organizations_selected = [this.organizations.find(opt => opt.name === this.formData.organization)];
                } else if(this.action == 'add_organization_for_support_ticket')
                {   if(this.formData.organization)
                    {
                        this.organizations_selected = this.organizations.find(opt => opt.name === this.formData.organization);
                        let users = this.$store.getters['persist/orgUsers'];
                        this.orgUsers = users.filter(user => user.organization_id == this.organizations_selected.id);
                        if(this.formData.user_id != null)
                        {
                          this.org_user = users.filter(user => user.id == this.formData.user_id);
                        }else{
                         this.org_user = '';
                        }
                    }else{
                        this.organizations_selected = '';
                        this.org_user = '';
                    }

                }
                else if (this.action == 'extend_due_date') {
                    this.task = { ...this.formData.task };
                    this.task.activity_type = parseInt(this.formData.type);
                    this.task.prms=this.formData.prms;

                    // if(this.activityTypes.extendADHDueDate == this.task.activity_type)
                    //     this.task.prev_due_date = this.task.adh_due_date ? new Date(this.task.adh_due_date).toISOString().slice(0, 10) : '';
                    // else if(this.activityTypes.extendDeveloperDueDate == this.task.activity_type)
                    //     this.task.prev_due_date = this.task.dev_due_date? new Date(this.task.dev_due_date).toISOString().slice(0, 10) : "";
                    // else
                    //     this.task.prev_due_date = this.task.due_date ? new Date(this.task.due_date).toISOString().slice(0, 10):'';
                    this.getDueDateHistory();
                } else if (this.action == 'assign_to') {
                    this.task = { ...this.formData.task };
                    this.assigned_to =  {full_name: this.task.assigned_to.name, id: this.task.assigned_to.id};
                    this.task.due_date = this.task.due_date ? this.task.due_date_time : '';
                    this.task.dev_due_date =  this.task.dev_due_date ? this.formateDate(this.task.dev_due_date): '';
                    this.task.adh_due_date = this.task.adh_due_date? this.formateDate(this.task.adh_due_date): '';
                   this.user.team= this.teams.find(opt => opt.id === this.task.team_id);
                }else if (this.action == 'create') {
                    this.task.id= null;
                    this.task.title= '';
                    this.task.description= '',
                    this.task.due_date= '',
                    this.task.status= 1,
                    this.task.document = null;
                    this.task.pr_link = '';
                    this.assigned_to={};
                    this.task_type={};
                    this.organizations_selected=[];
                    this.task.support_ticket_id= '';
                    this.task.extend_due_date= '';
                    this.task.extend_due_date_comment= '';
                    this.software= {};
                    this.qa_to='';
                }
            },
            async getOrganizations(){
                await this.$store.dispatch("organizations/getAll",[{status: 1}]).then((res) => {
                   this.organizations = res;
                    if(this.action == 'add_task_from_Support_ticket'){
                        this.organizations_selected = [this.organizations.find(opt => opt.name === this.formData.organization)];
                    }else if(this.action == 'add_organization_for_support_ticket'){
                        this.organizations_selected = this.organizations.find(opt => opt.name === this.formData.organization);
                        let users = this.$store.getters['persist/orgUsers'];
                        this.orgUsers = users.filter(user => user.organization_id == this.organizations_selected.id);
                    }else if( this.action == "edit"){
                    let slt_org= [];
                    this.formData.task.organizations_obj.forEach((key) => {
                        this.organizations.find(opt => opt.id === key.organization_id);
                        slt_org.push({id:key.organization_id,name:key.name});
                    });
                    this.organizations_selected = slt_org;
                        }
                    });


            },
            formateDate(date) {
                var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;

                return [year, month, day].join('-');
            },
            saveOnHoldReason()
            {
                    let on_hold_validate =  this.validateOnHoldReason();

                    if (on_hold_validate) {
                        this.mini_loading = true;

                        let formData = {
                            id: this.formData.task_id,
                            type: this.formData.type,
                            status: this.formData.status,
                            description: this.onholddescription,
                            prms: this.formData.permission,
                        };
                        this.$store.dispatch("tasks/updateStatus", [formData]).then((response) => {
                            this.mini_loading = false;
                            this.onholddescription = '';
                            if(response && response.error){
                                this.serverValidationErrors(response.error);
                            }else{
                                let filtersData = [this.$store.getters['tasks/currentPage'], this.$store.getters['tasks/filters'], []]
                                this.$store.dispatch("tasks/getAll", filtersData).then(() => {
                                    window.$('#modal').modal('hide');
                                   this.$toast.success(response);
                                    this.skeletonLoader = false;
                                });
                            }
                        });
                    }
            },

            updateOrganizations(){
                let slt_org= [];
                this.formData.task.organizations_obj.forEach((key) => {
                    this.organizations.find(opt => opt.id === key.organization_id);
                    slt_org.push({id:key.organization_id,name:key.name});
                });
                this.organizations_selected = slt_org;
            },
            Changeteam(){
                this.assigned_to = {};
            },
            save(){
                if(this.user && this.user.team && this.user.team.id !== null && this.user.team.id !== undefined)
                {
                    this.task.user_team = this.user.team.id;

                }else{
                    this.task.user_team='';
                }
                this.mini_loading = true;
                let method = '';
                let is_form_valid = true;
                let dev_form_validate = true;


                if(this.action == 'create' || this.action == 'edit'){
                    is_form_valid = this.validateCreateUpdateForm();

                    if(this.task.req_due_date == '' && this.task.due_date && this.action == 'create'){
                        this.task.req_due_date = this.task.due_date;
                    }
                    method = (this.action == 'create')? "add": "update";
                    if(method === "update"){

                        this.task.assigned_to_selected =this.assigned_to;
                        this.user_team =this.user.team;
                    }
                }else if(this.action == 'add_task_from_Support_ticket'){
                    method = "add";
                    is_form_valid = this.validateAddTaskFromSupportTicketForm();
                }else if(this.action == 'extend_due_date'){
                    method = "extendDueDate";
                    is_form_valid = this.validateExtendDueDateForm();
                }else if(this.action == 'assign_to'){
                    method = "assign";
                    is_form_valid = this.validateAssignedToForm();

                }else if(this.action == 'developer_report'){
                    method = "developerReport";
                    dev_form_validate =  this.validateDeveloperReportForm();
                    this.mini_loading = true;
                    if (dev_form_validate) {
                        let formData = {
                            task_id: this.formData.task_id,
                            type: this.formData.type,
                            description: this.dev_description,
                            date: this.rpt_date,
                            reports: this.reports,
                            prms: this.formData.permission,
                        };
                        
                        this.$store.dispatch("tasks/"+method, {formData}).then((response) => {
                            this.mini_loading = false;
                            if(response && response.error){
                                this.serverValidationErrors(response.error);
                            }
                            else{
                                    this.$toast.success(response);
                                    window.$('#modal').modal('hide');
                                }
                        });
                    } else {
                        this.mini_loading = false;
                    }
                    return;

                }

                if (is_form_valid) {
                    this.$store.dispatch("tasks/"+method, [this.task]).then((response) => {
                        this.mini_loading = false;
                        if(response && response.error){
                            this.serverValidationErrors(response.error);
                        }else{
                            this.skeletonLoader = true;
                            if(this.action != 'add_task_from_Support_ticket'){
                                let filtersData = [this.$store.getters['tasks/currentPage'], this.$store.getters['tasks/filters'], []]
                                this.$store.dispatch("tasks/getAll", filtersData).then(() => {
                                    window.$('#modal').modal('hide');
                                    this.$toast.success(response);
                                    this.skeletonLoader = false;
                                });
                            }else {
                              this.$toast.success(response);
                              window.$('#modal').modal('hide');
                            }
                        }
                    });
                } else {
                    this.mini_loading = false;
                }
            },
            validateCreateUpdateForm () {
               if(this.software === null){
                    this.$toast.error('The software field is required');
                        return false;
                }
                if(this.task.title == '' || this.task.description == '' || this.priority == undefined ||
                        this.organizations_selected.length == 0 || !this.software.id || this.task_type.value == undefined){
                    if(!this.software.id){
                        this.$toast.error('The software field is required');
                    }
                    if(this.organizations_selected.length == 0){
                        this.$toast.error('The customers field is required');
                    }
                     if(this.priority == undefined){
                        this.$toast.error('The priority field is required');
                    }
                      if(this.task_type.value == undefined){
                        this.$toast.error('The task type field is required');
                    }
                     
                      if (this.task.req_due_date == ''&&(this.role == 4 || this.role == 10)) {
                        this.$toast.error('The Requird due date field is required');
                    }
                      if (this.task.description == '' ) {
                        this.$toast.error('The description field is required');
                    }
                     if (this.task.title == '') {
                        this.$toast.error('The title field is required');
                    }
                    return false;
                }else{
                    this.task.assigned_to = this.assigned_to.id;
                    this.task.status = (this.task.user_team == "") ? 0 : 1;
                    this.task.priority = this.priority.value;
                    this.task.task_type = this.task_type.value;
                    this.task.product = this.software.id;
                    this.task.organizations = this.organizations_selected.map(({ id }) => id);
                    return true;
                }
            },
            validateAddTaskFromSupportTicketForm () {
                if(this.software === null){
                    this.$toast.error('The software field is required');
                        return false;
                }
                if(this.task.title == '' || this.task.description == '' || this.task.req_due_date == ''|| this.priority.value == undefined  || !this.software.id || this.task_type.value == undefined){
                    if (this.task.title == '') {
                        this.$toast.error('The title field is required');
                    }
                    if (this.task.description == '' ) {
                        this.$toast.error('The description field is required');
                    }
                     if ( this.task.req_due_date == '' ) {
                        this.$toast.error('The required due date field is required');
                    }
                    if(this.task_type.value == undefined){
                        this.$toast.error('The task type field is required');
                    }
                    if (this.priority.value == undefined) {
                        this.$toast.error('The priority field is required');
                    }
                    if(this.organizations_selected.length == 0){
                        this.$toast.error('The customers field is required');
                    }
                    if(!this.software.id){
                        this.$toast.error('The software field is required');
                    }
                    this.mini_loading=false;
                    return false;
                }else{
                    this.task.priority = this.priority.value;
                    this.task.task_type = this.task_type.value;
                    this.task.status = (this.task.user_team == "") ? 0 : 1;
                    this.task.organizations = this.organizations_selected.map(({ id }) => id);
                     this.task.product = this.software.id;
                    return true;
                }
            },
            validateExtendDueDateForm () {
                if (this.task.extend_due_date == ''|| this.task.extend_due_date === undefined || this.task.extend_due_date_comment == '' || this.task.extend_due_date_comment === undefined) {
                    if (this.task.extend_due_date_comment == '' || this.task.extend_due_date_comment === undefined) {
                        this.$toast.error('Reason field is required.');
                    }
                    if ( this.task.extend_due_date == '' || this.task.extend_due_date === undefined) {
                        this.$toast.error('Date field is required.');
                    }

                    this.mini_loading=false;
                    return false;
                } else {
                    return true;
                }
            },
            getDueDateHistory () {
                this.loader = true;
                this.$store.dispatch("tasks/getActivity",[this.task.id,this.formData.type]).then((response) => {
                    this.due_date_history = response;
                    this.task.prev_due_date = this.due_date_history.length > 0 ? this.due_date_history[this.due_date_history.length-1].due_date:'';
                    if(this.task.prev_due_date){
                        this.task.min_date = this.task.prev_due_date;
                    }else{
                        this.task.min_date = new Date().toISOString().slice(0, 10);
                    }
                    this.loader = false;
                });
            },
            getCurrentDueDate(){
                this.$store.dispatch("tasks/getCurrentDueDate",[this.taskForm]).then((response) => {
                    this.due_date_history = response.due_date;
                });
            },
            validateDeveloperReportForm () {
                let isValid = true;
                        this.reports.forEach(report => {
                        if (!report.title.trim() || !report.hours.toString().trim()) {
                            report.isValid = false;
                            isValid = false;
                        } else {
                            report.isValid = true;
                        }
                        });
                    if(!isValid)
                    {
                        this.$toast.error('Progress field fields are required');
                    }
                return isValid;
            },
            validateOnHoldReason () {
                if (this.onholddescription == '') {
                    this.$toast.error('The reason field is required');
                    this.mini_loading=false;
                    return false;
                } else {
                    return true;
                }
            },
            validateAssignedToForm(){
                if(this.role != 8 && this.task.due_date==''){
                    if(this.task.due_date == ''){
                        this.$toast.error('The due date field is required');
                    }
                    // if(this.assigned_to.id == undefined){
                    //     this.$toast.error('The developer field is required');
                    // }
                    this.mini_loading=false;
                    return false;
                } else if(this.role == 8 && this.task.dev_due_date==''){
                      this.$toast.error('The dev due date field is required');
                      this.mini_loading=false;
                      return false;
                }
                else{
                    this.task.assigned_to = this.assigned_to.id;
                    this.task.status = 1;
                    return true;
                }
            },
            serverValidationErrors(error = []){
                if(error.hasOwnProperty('title')){
                     this.$toast.error('The title field is required');
                }
                if(error.hasOwnProperty('description')){
                     this.$toast.error('The description field is required');
                }
                if(error.hasOwnProperty('due_date')){
                     this.$toast.error('The due date field is required');
                }
                // if(error.hasOwnProperty('assigned_to')){
                //    this.$toast.error('The developer field is required');
                // }
                if(error.hasOwnProperty('priority')){
                    this.$toast.error('The priority field is required');
                }
            },
        }
    }
</script>
<style scoped>
input[type="date"]{
  position: relative;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    background-position: right;
    background-size: auto;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    top: 6px !important;
    right: 2%;
    width: auto;
}
.text-dark{
    color: rgb(72, 166, 166) !important;
}
.input-group .input-group-append .btn {
  border: 1px solid #ced4da; /* Match the input's border */
  border-left: 0; /* Remove the left border to blend with the input field */
}

.input-group .btn-outline-secondary {
  color: #dc3545; /* Change the icon's color to red or any color you prefer */
  background-color: transparent; /* Transparent background */
}

.add-more-button {
  margin-top: 20px; /* Add some space above the "Add More" button */
  background-color: #007bff; /* Bootstrap primary color */
  color: white; /* Text color */
}
.modal-body button.add-more-cross-btn{
    text-align: left;
    background: transparent;
    color: #DF5439 !important;
    border: 1px solid #DF5439;
    border-radius: 8px;
    font-family: Poppins;
    font-size: 13px;
    font-weight: 500;
    line-height: 19.5px;

}

.add-more-button:hover {
  background-color: #0056b3; /* Darker shade on hover */
}

/* Custom styles for the button */
.btn-outline-secondary {
  border-color: #dc3545;
}
.btn-outline-secondary:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
}
/* Custom styles for the button */
.modal-body button.add-more-btn{
    width: auto;
    display: inline-flex;
    align-items: center;
    text-align: left;
    background: transparent;
    color: #48A6A6 !important;
    border: 2px dashed #48A6A6;
    border-radius: 16px;
    font-family: Poppins;
    font-size: 13px;
    font-weight: 500;
    line-height: 19.5px;
    text-align: left;
    padding: 8px 12px;
    white-space: nowrap;

}
.form-control{
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
}
</style>